import { getAuth } from 'firebase/auth';

interface FirebaseUserClaims {
  user_id: string;
  email: string;
  firebase: {
    tenant: string;
  };
  limepay: {
    merchantId: string;
    marketplaceId: string;
  };
}

export interface User {
  claims: FirebaseUserClaims;
}

const getCurrentUser = async (): Promise<User | null> => {
  const currentUser = getAuth().currentUser;

  if (!currentUser) return null;

  const { claims } = await currentUser.getIdTokenResult();

  return {
    claims: claims as unknown as FirebaseUserClaims,
  };
};

export default getCurrentUser;
